import {
  PasswordInput as MantinePasswordInput,
  PasswordInputProps,
} from '@mantine/core';

export type IPasswordInputProps = PasswordInputProps;

/** @registry Design-layer pass-through over Mantine PasswordInput; import this instead of @mantine/core PasswordInput outside src/design. Extend here when PasswordInput needs house behavior. */
export const PasswordInput = MantinePasswordInput;
